import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  brandColours,
  sectionPaddings,
} from '../utilities';
import { Container, Heading, HTMLContent } from './ui';

const StyledIntroContent = styled.section`
  ${sectionPaddings()};
`;

const StyledIntroContentInner = styled.div`
  text-align: center;
`;

const StyledIntroContentHeading = styled(Heading)`
  margin-bottom: 18px;

  ${minBreakpointQuery.small`
    margin-bottom: 22px;
  `}

  ${minBreakpointQuery.medium`
    margin-bottom: 26px;
  `}
`;

const IntroContent = ({ heading, content }) => {
  return (
    <StyledIntroContent>
      <Container>
        <StyledIntroContentInner>
          <StyledIntroContentHeading colour={brandColours.primary}>
            {heading}
          </StyledIntroContentHeading>
          <HTMLContent content={content} />
        </StyledIntroContentInner>
      </Container>
    </StyledIntroContent>
  );
};

export default IntroContent;
